import * as Yup from 'yup';

export default Yup.string()
  .test({
    name: 'phoneNumber',
    message: 'Il formato del numero telefonico non è valido',
    test: (value) => /^[03+][0-9.\- ]{8,}$/.test(value)
      && value.split('').filter((char) => char === value[0]).length !== value.length,
  });
